// import SliderArrow from "~/assets/images/icons/slider-arrow.svg?inline";

export default {
  name: "user_role"
};
